<template>
    <div class="article-shoes-alex">
        <p>
            If you've seen Lauren in a video, then she's most likely wearing Alex by SwayD! They're super popular in the
            scene, and for good reason.
        </p>
        <p>
            They look just like regular sneakers, while actually being very comfortable, supportive and flexible dance
            shoes! They have a cushioned insole as well as a soft exterior. They will complete any dance outfit,
            creating a sporty and elegant vibe combined.
        </p>
        <p>Why not jump on the SwayD website and grab a pair?</p>
        <div class="flex flex-row space-x-2">
            <button-primary buttonText="US" buttonUrl="https://swaydshoes.com/product/alex/ref/60/"></button-primary>
            <button-primary buttonText="Europe" buttonUrl="https://swayd.eu/product/alex/ref/28/"></button-primary>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ArticleShoesAlex',
};
</script>
